import React from 'react';
import {
  Content,
  ContentHeader,
  PageWithHeader,
  Progress,
} from '@backstage/core-components';
import {
  ProjectStatsCard,
  useGithubStatisticsRevenue,
} from '@internal/backstage-plugin-github-statistics';
import { Grid, Typography } from '@material-ui/core';
import useAsync from 'react-use/lib/useAsync';

function formatCurrency(value: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function InnerSourceProgressPage() {
  const revenueStatisticsApi = useGithubStatisticsRevenue();

  const { value, loading } = useAsync(async () => {
    return revenueStatisticsApi();
  }, []);
  if (loading || !value) {
    return <Progress />;
  }

  return (
    <PageWithHeader title="InnerSource Progress Dashboard" themeId="home">
      <Content>
        <ContentHeader title="Global Gains through InnerSource" />
        <Typography variant="h6" style={{ margin: '20px 0' }}>
          Total: {formatCurrency(value.total)}
        </Typography>
        <Typography variant="h6">
          On Average per Project: {formatCurrency(value.average)}
        </Typography>
        <Grid container spacing={3} style={{ marginTop: '20px' }}>
          <Grid item xs={12} md={8}>
            <ProjectStatsCard />
          </Grid>
        </Grid>
      </Content>
    </PageWithHeader>
  );
}
